import {
  GUI_EMAIL,
  GUI_EMAIL_SUCCESS,
  GUI_EMAIL_FAILURE,
  SHOW_GUI_EMAIL,
} from './actionTypes';

export const guiEmail = (dataPost, callback) => ({
  type: GUI_EMAIL,
  dataPost,
  callback,
});

export const guiEmailSuccess = (data) => ({
  type: GUI_EMAIL_SUCCESS,
  payload: data,
});

export const guiEmailFailure = () => ({
  type: GUI_EMAIL_FAILURE,
});

export const showModalGuiEmail = (dataPost) => ({
  type: SHOW_GUI_EMAIL,
  dataPost,
});
